<template lang="">
	<sf-data-table ref="table" :columns="columns" :rows="rows" />
</template>
<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@common/QueueRecordCount/store/helpers';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		columns() {
			return [
				{
					label: this.getMessage_('SWCC000707'),
					prop: 'queueId',
					minWidth: '60px',
					highlight: true
				},
				{
					label: this.getMessage_('SWCC000708'),
					prop: 'queueName',
					minWidth: '140px'
				},
				{
					label: this.getMessage_('SWCC000709'),
					prop: 'queueType',
					minWidth: '50px'
				},
				{
					label: this.getMessage_('SWCC000354'),
					prop: 'cnt',
					minWidth: '45px'
				},
				{
					label: this.getMessage_('SWCC000707'),
					prop: 'queueId2',
					minWidth: '60px',
					highlight: true
					//clickEvent: this.openLink
				},
				{
					label: this.getMessage_('SWCC000708'),
					prop: 'queueName2',
					minWidth: '140px'
				},
				{
					label: this.getMessage_('SWCC000709'),
					prop: 'queueType2',
					minWidth: '50px'
				},
				{
					label: this.getMessage_('SWCC000354'),
					prop: 'cnt2',
					minWidth: '45px'
				}
			];
		},
		rows() {
			return this.$sf_cloneObj(this.queueRecordCountList);
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods
	},
	created() {}
};
</script>
<style></style>
